var ko = require('knockout');
var $ = require('jquery');

ko.components.register('checkout-course-list', {
  viewModel: require('./checkout-course-list'),
  template: require('./checkout-course-list.template')
});

$('[data-checkout-course-list]').each(function() {
  ko.applyBindings({}, this);
});
